export default __webpack_public_path__ + "static/media/element_64.931dc24b.jpg";